import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { readNavContext } from '../utils/navContext';
import { resolveWarehouseLandingPath } from '../utils/warehouseNavigation';

const HomeRouter: React.FC = () => {
  const { effectiveUser, previewPersonaId } = useAuth();
  return (
    <Navigate to={resolveWarehouseLandingPath(effectiveUser, readNavContext(), previewPersonaId)} replace />
  );
};

export default HomeRouter;
